export default "__VITE_ASSET__PYJ$FzoCfH3rd7T3_vIteQ__"